enum ConsumptionReason {
  Propulsion = "Propulsion",
  CargoHeating = "Cargo Heating",
  BallastExchange = "Ballast Exchange",
  Other = "Other",
  Manoeuvring = "Manoeuvring",
}

export default ConsumptionReason;
